import React, { useState, useEffect } from "react";
import mission_logo from "../assets/mission_logo.svg";
import "@fontsource/plus-jakarta-sans";
import { useNavigate } from "react-router-dom";
import { messaging } from "../firebase.js";

const LoginPage = () => {
  const [gid, setGid] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fcmMemberToken = localStorage.getItem("fcmMemberToken");
    if (fcmMemberToken) {
      navigate("/projections");
    }
  }, [navigate]);

  const saveMemberFCMToken = async (token) => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/projection/saveMemberFCMToken`;
    const requestBody = {
      fcm_tokenid: token,
      memberid: gid,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        console.log("FCM token sent successfully:", token);
        //localStorage.setItem("fcmTokenSent", "true");
      } else {
        console.error("Failed to send FCM token. Status:", response.status);
      }
    } catch (error) {
      console.error("Error saving FCM token:", error);
    }
  };

  const handleLogin = async () => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/login`;
    if (!gid || !password) {
      setError("Please enter both username and password.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ gid, password }),
      });

      if (res.ok) {
        let newToken = null;
        if (
          messaging &&
          typeof Notification !== "undefined" &&
          Notification.permission !== "denied"
        ) {
          try {
            newToken = await messaging.getToken();
          } catch (fcmError) {
            console.warn(
              "Failed to get FCM token (notifications may be blocked or unsupported):",
              fcmError
            );
          }
        }

        if (newToken) {
          // Store the token in localStorage or send it to your server
          localStorage.setItem("fcmMemberToken", newToken);
          await saveMemberFCMToken(newToken);
        } else {
          console.warn("No FCM token obtained; proceeding with login.");
          localStorage.setItem("fcmMemberToken", "logged_in");
        }
        localStorage.setItem("memberGid", gid);
        window.location.href = "/projections";
      } else {
        alert("Invalid credentials");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white min-h-screen font-jakarta shadow-lg">
      <header className="grid grid-cols-3 items-center p-4 bg-white shadow-2xl">
        <div className="w-12 h-12">
          <img
            src={mission_logo}
            alt="Logo"
            className="max-w-6xl max-h-screen object-contain"
          />
        </div>

        {/* Center Title */}
        <div className="text-center font-jakarta font-bold text-xl whitespace-nowrap">
          SRMD Meal Tracker
        </div>

        {/* Empty div to balance grid */}
        <div></div>
      </header>

      <div className="flex flex-col items-center justify-center mt-24 px-6">
        <h2 className="text-2xl font-bold text-[#1f0f4a] mb-6">Login</h2>

        <div className="w-full mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Username / GID
          </label>
          <input
            type="text"
            value={gid}
            onChange={(e) => setGid(e.target.value)}
            placeholder="Enter your username"
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400"
          />
        </div>

        <div className="w-full mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400"
          />
        </div>

        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

        <button
          onClick={handleLogin}
          disabled={loading}
          className={`w-full py-2 rounded-lg font-semibold text-white ${
            loading ? "bg-pink-300" : "bg-pink-500 hover:bg-pink-600"
          } transition-all`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
